'use es6';

export var PUBLIC_BOOK_ENDPOINT = "meetings-public/v1/book";
export var LINK_ENDPOINT = "meetings-public/v1/link";
export var TEST_AVAILABILITY_ENDPOINT = 'meetings-public/v1/test-availability';
export var BRANDING_ENDPOINT = 'branding/v1';
export var TROUBLESHOOT_ENDPOINT = 'meetings-public/v1/troubleshoot';